(ns client-portal.client.smart-ordering.sessions.drill
  (:require [client-portal.client.components.drill :as drill]
            [client-portal.client.voice-insights.sessions.data :as vi.sessions.d]
            [client-portal.client.voice-insights.sessions.drill :as vi.drill]
            [shared.core.router :as router]
            [shared.core.util :as util]))

(defn sessions-query-params [{:keys [query-params] :as context} drill click report-filters]
  (let [constraints (drill/constraints drill click context report-filters)]
    (util/remove-nil-from-map
      (merge (select-keys query-params [:ns])
             (drill/layout-query-params context constraints report-filters)
             {:fd (vi.sessions.d/filters->query-param
                    (vi.drill/session-filters constraints #{"tags" "day-of-week" "time-of-day" "day-part" "duration"}))}))))

(defn open-sessions [e context drill click report-filters]
  (router/open-route-based-on-event e [:so/sessions nil (sessions-query-params context drill click report-filters)]))
